/*
 * SPDX-FileCopyrightText: 2023 SEIVA Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const customerTicketing = {
  customerTicketing: {
    mainLogoLabel: 'SEIVA',
    mainTitle: 'Emissão de bilhetes de cliente',
    ticketId: 'IDENTIFICAÇÃO',
    createdOn: 'Criado em',
    changedOn: 'Modificado em',
    category: 'Categoria',
    associatedTo: 'Associado a',
    ticketPurchaseOrderNumber: 'Número do pedido',
    optionalField: '(opcional)',
    status: 'Estado',
    message: 'Mensagem',
    cancel: 'Cancelar',
    submit: 'Enviar',
    uploadFile: 'Carregar arquivo',
    fileSizeLimit: 'Limite de tamanho do arquivo: {{count}} MB',
    maximumAttachment: 'Máximo de um anexo por mensagem',
    errorMensagem: 'Algo deu errado.',
    charactersLeft: 'Caracteres à esquerda: {{count}}',
    customerService: 'Atendimento ao Cliente',
  },
  customerTicketingList: {
    ticketCategory: 'Categoria',
    subject: 'Assunto',
    ticketCategoria: 'Categoria',
    sortSubtitle: 'Classificar por',
    sortOrders: 'Critérios de classificação',
    noTickets: `Você não tem nenhuma solicitação`,
    requestTitle: 'Todos os pedidos',

    mobile: {
      ticketIdFull: 'ID IDENTIFICAÇÃO',
    },
  },
  createCustomerTicket: {
    createNewTicket: 'Adicionar',
    addRequest: 'Adicionar solicitação',
    subject: 'Assunto',
    category: 'Categoria',
    associateTo: 'Associe-se com',
    ticketCreated: 'Solicitação criada.',
    optionallySelectAssociatedObject: 'Selecione a opção',
    selectCategory: 'Selecione a categoria',
  },
  customerTicketingDetails: {
    requestReopened: 'Aplicativo reaberto.',
    requestClosed: 'Aplicativo fechado, pode ser reaberto se necessário.',
    reopenRequest: 'Pedido de reabertura',
    closeRequest: 'Fechar aplicação',
    ticketNotFound: 'Ticket no encontrado.',
  },
};
